import { gql } from '@apollo/client';
import { OrderFragments } from '../../../../graphql/order.graphql';
import { Order } from '../../../order';
import { CustomField } from '../../../custom_field';
import { ValidSourceContainerProps } from '../../../../util/containers.util';
import { SystemStockLocation } from '../../../stock_location/stockLocation';
import { ProductTransactionType } from '../../../productTransaction';

export namespace Unilever {
  export const companyIds = ['8391156d-7ec5-437b-bf76-e9b31d09af97', '9b582482-9b7a-4204-9198-bee5b6849374'];

  export const qaCompanyId = '9b582482-9b7a-4204-9198-bee5b6849374';

  export const containerProductId = '5f6a7b8c-9d0e-1a2b-3c4d-5e6f7a8b9c0d';
  export const containerBatchCodeId = '1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d';

  export const disabledCustomField = (field: CustomField) =>
    field.generated && Unilever.companyIds.includes(field.companyId);

  export const isValidSourceContainer = ({
    transaction,
    container,
    products,
    productMasterData,
  }: ValidSourceContainerProps) => {
    let items = [...products];

    if (Unilever.companyIds.includes(transaction.companyId) && transaction.type === ProductTransactionType.outbound) {
      if (container.stockLocationId === SystemStockLocation.id) {
        return container.customFields.get(containerProductId)?.value === productMasterData?.productNumber;
      }
    }

    if (transaction.product.fromStockLocationId) {
      items = items.filter(p => p.stockLocationId === transaction.product.fromStockLocationId);
    }
    if (transaction.product.lotId) items = items.filter(p => p.lotId === transaction.product.lotId);

    return items.filter(p => p.containerId === container.id).length;
  };

  export const processMessage = gql`
    mutation ProcessMessage($message: String!) {
      processMessage(message: $message) {
        ...Order
      }
    }
    ${OrderFragments.order}
  `;

  export interface ProcessMessageVariables {
    message: string;
  }

  export interface ProcessMessageResponse {
    processMessage: Order[];
  }
}
